var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
    },
    [
      _c(
        "el-form",
        {
          ref: "pageForm1",
          staticClass: "page-form",
          attrs: { model: _vm.PersonInfo, rules: _vm.pageRules1 },
        },
        [
          _c("p", { staticClass: "sub_t" }, [_vm._v("PersonInfo")]),
          _vm._v(" "),
          _c(
            "el-row",
            { attrs: { gutter: 32 } },
            [
              _c(
                "el-col",
                { attrs: { span: 10 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "FirstGivenName",
                        label: "First Given Name",
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "text",
                          "auto-complete": "off",
                          placeholder: "Please fill in",
                        },
                        model: {
                          value: _vm.PersonInfo.FirstGivenName,
                          callback: function ($$v) {
                            _vm.$set(_vm.PersonInfo, "FirstGivenName", $$v)
                          },
                          expression: "PersonInfo.FirstGivenName",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 10 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: { prop: "FirstSurName", label: "First Sur Name" },
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "text",
                          "auto-complete": "off",
                          placeholder: "Please fill in",
                        },
                        model: {
                          value: _vm.PersonInfo.FirstSurName,
                          callback: function ($$v) {
                            _vm.$set(_vm.PersonInfo, "FirstSurName", $$v)
                          },
                          expression: "PersonInfo.FirstSurName ",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 10 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "Birth", label: "Date of Birth" } },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          "value-format": "yyyy-MM-dd",
                          "picker-options": _vm.pickerOptions,
                          type: "date",
                          placeholder: "Please select",
                        },
                        model: {
                          value: _vm.PersonInfo.Birth,
                          callback: function ($$v) {
                            _vm.$set(_vm.PersonInfo, "Birth", $$v)
                          },
                          expression: "PersonInfo.Birth",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form",
        {
          ref: "pageForm2",
          staticClass: "page-form",
          attrs: { model: _vm.NationalIds, rules: _vm.pageRules2 },
        },
        [
          _c("p", { staticClass: "sub_t" }, [_vm._v("NationalIds")]),
          _vm._v(" "),
          _c(
            "el-row",
            { attrs: { gutter: 32 } },
            [
              _c(
                "el-col",
                { attrs: { span: 10 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "Number", label: "Number" } },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "text",
                          "auto-complete": "off",
                          placeholder: "Please fill in",
                        },
                        model: {
                          value: _vm.NationalIds.Number,
                          callback: function ($$v) {
                            _vm.$set(_vm.NationalIds, "Number", $$v)
                          },
                          expression: "NationalIds.Number",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 10 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "Type", label: "Type" } },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "text",
                          "auto-complete": "off",
                          placeholder: "Please fill in",
                        },
                        model: {
                          value: _vm.NationalIds.Type,
                          callback: function ($$v) {
                            _vm.$set(_vm.NationalIds, "Type", $$v)
                          },
                          expression: "NationalIds.Type",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form",
        {
          ref: "pageForm3",
          staticClass: "page-form",
          attrs: { model: _vm.Location, rules: _vm.pageRules3 },
        },
        [
          _c("p", { staticClass: "sub_t" }, [_vm._v("Location")]),
          _vm._v(" "),
          _c(
            "el-row",
            { attrs: { gutter: 32 } },
            [
              _c(
                "el-col",
                { attrs: { span: 10 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "BuildingNumber",
                        label: "Building Number",
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "text",
                          "auto-complete": "off",
                          placeholder: "Please fill in",
                        },
                        model: {
                          value: _vm.Location.BuildingNumber,
                          callback: function ($$v) {
                            _vm.$set(_vm.Location, "BuildingNumber", $$v)
                          },
                          expression: "Location.BuildingNumber",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 10 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "BuildingName", label: "Building Name" } },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "text",
                          "auto-complete": "off",
                          placeholder: "Please fill in",
                        },
                        model: {
                          value: _vm.Location.BuildingName,
                          callback: function ($$v) {
                            _vm.$set(_vm.Location, "BuildingName", $$v)
                          },
                          expression: "Location.BuildingName",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 10 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "UnitNumber", label: "Unit Number" } },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "text",
                          "auto-complete": "off",
                          placeholder: "Please fill in",
                        },
                        model: {
                          value: _vm.Location.UnitNumber,
                          callback: function ($$v) {
                            _vm.$set(_vm.Location, "UnitNumber", $$v)
                          },
                          expression: "Location.UnitNumber",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 10 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "StreetName", label: "Street Name" } },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "text",
                          "auto-complete": "off",
                          placeholder: "Please fill in",
                        },
                        model: {
                          value: _vm.Location.StreetName,
                          callback: function ($$v) {
                            _vm.$set(_vm.Location, "StreetName", $$v)
                          },
                          expression: "Location.StreetName",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 10 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { prop: "County", label: "County" } },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "text",
                          "auto-complete": "off",
                          placeholder: "Please fill in",
                        },
                        model: {
                          value: _vm.Location.County,
                          callback: function ($$v) {
                            _vm.$set(_vm.Location, "County", $$v)
                          },
                          expression: "Location.County",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }